import { mapActions } from 'vuex'
import { regType } from '@utils/regExp'



export default {
  data () {
    return {
      inputWith: 12,

      prizeFormRules: {
        name: [
          {required: true, message: '奖品名称不能为空', trigger: 'blur'},
        ],
        description: [
          {required: true, message: '奖品描述不能为空', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '奖品类型不能为空', trigger: 'blur'},
        ],
        img: [
          {required: true, message: '奖品图片不能为空', trigger: 'blur'},
        ],
        package_time_limit: [
          {required: true, message: '券包的有效期不能为空', trigger: 'blur'},
          {validator: this.positiveIntegerValidator, trigger: 'blur'},
        ],
        coupon_time_limit: [
          {required: true, message: '券的有效期不能为空', trigger: 'blur'},
          {validator: this.positiveIntegerValidator, trigger: 'blur'},
        ],
        coupon_amount: [
          {required: true, message: '券总数不能为空', trigger: 'blur'},
          {validator: this.positiveIntegerValidator, trigger: 'blur'},
        ],
        surprise_coupon_after: [
          {required: true, message: '惊喜券位置不能为空', trigger: 'blur'},
          {validator: this.positiveIntegerValidator, trigger: 'blur'},
        ],
      },

      form: {
        name: '',
        description: '',
        type: null,
        img: '',
        package_time_limit: '',
        coupon_time_limit: '',
        coupon_amount: '',
        surprise_coupon_after: '',
        coupons: [],
      },

      options: {
        fairPrizeType: [],
        fairPrizeCouponType: [],
      },
    }
  },



  computed: {},



  created () {
    if (this.$route.params.prizeId) { // 修改奖品
      request.all.page([
        request('getFairPrizeOptions'),
        request('getFairPrizeDetail', this.$route.params.prizeId),
      ]).then(([{
        data: optionData,
      }, {
        data: prizeData,
      }]) => {
        this.setFairPrizeOptions(optionData)
        Object.assign(this.form, prizeData)
      })
    } else { // 添加奖品
      request.common('getFairPrizeOptions').then(({data}) => {
        this.setFairPrizeOptions(data)
      })
    }
  },



  methods: {
    ...mapActions([]),


    setFairPrizeOptions (data) {
      this.options.fairPrizeType = data.fairPrizeType
      this.options.fairPrizeCouponType = data.fairPrizeCouponType
    },


    onChangePrizeImg (file, fileList) {
      let isImg = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
      let isLt2M = file.raw.size / 1024 / 1024 < 2
      if (!isImg) {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadPrizeImg(file.raw)
    },


    onUploadPrizeImg (file) {
      let formData = new FormData()
      formData.append('file', file)
      return request.common('uploadFair', formData).then(({data}) => {
        this.form.img = data
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },


    onRemovePrizeImg (file, fileList) {
      this.form.img = ''
    },


    // 添加券
    addCoupon () {
      const couponData = {
        type: null,
        amount: '',
        order_price_limit: '',
        num: '',
        status: 1,
        desc: '',
      }

      this.form.coupons.push(couponData)
    },


    // 删除券
    deleteCoupon (couponIndex) {
      this.form.coupons.splice(couponIndex, 1)
    },


    // 修改奖品类型
    onChangePrizeType () {
      this.form.package_time_limit = ''
      this.form.coupon_time_limit = ''
      this.form.coupon_amount = ''
      this.form.surprise_coupon_after = ''
      this.form.coupons = []
    },


    // 验证正整数输入
    positiveIntegerValidator (rule, value, callback) {
      if (!regType('number').test(String(value))) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    },



    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let submitModel = null

          switch (this.form.type) {
            default:
              submitModel = this.submitDefault()
              break
            case 40:
              submitModel = this.submitCoupon()
              break
          }

          if (!submitModel) return

          request.common(
            this.$route.params.prizeId ? 'editFairPrize' : 'createFairPrize',
            this.$route.params.prizeId ? {
              id: this.$route.params.prizeId,
              data: submitModel,
            } : submitModel,
          ).then((res) => {
            this.$router.push({name: '活动奖品管理'})
          })
        }
      })
    },


    submitDefault () {
      const submitModel = {}
      const defaultKeys = [
        'name',
        'description',
        'type',
        'img',
      ]

      for (let k in this.form) {
        if (defaultKeys.indexOf(k) >= 0) {
          submitModel[k] = this.form[k]
        }
      }

      return submitModel
    },


    submitCoupon () {
      if (this.form.coupons.length < 1) {
        this.$message.error('请至少添加一张券')
        return false
      }

      for (let couponItem of this.form.coupons) {
        if (!couponItem.type) {
          this.$message.error('请选择券类型')
          return false
        } else if (!couponItem.amount || !regType('money').test(couponItem.amount)) {
          this.$message.error('请输入合适的添加券金额')
          return false
        } else if (!couponItem.amount || !regType('money').test(couponItem.amount)) {
          this.$message.error('请输入合适的添加券消耗条件')
          return false
        } else if (!couponItem.num || !regType('number').test(couponItem.num)) {
          this.$message.error('请输入合适的添加券数量')
          return false
        }
      }

      // 检查有效券的总数量
      let totalCouponNum = 0
      for (let couponItem of this.form.coupons) {
        if (couponItem.status === 1) {
          totalCouponNum += Number(couponItem.num)
        }
      }

      if (totalCouponNum !== Number(this.form.coupon_amount)) {
        this.$message.error('券总数必须等于所有有效券的数量之和')
        return false
      }

      return this.form
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/fair-prize/pages/FairPrizeEdit.js